//https://danielykpan.github.io/date-time-picker/
export const DATETIME_FORMATS = {
    fullPickerInput: {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric',hour12: false},
    datePickerInput: {year: 'numeric', month: 'numeric', day: 'numeric'},
    timePickerInput: {hour: 'numeric', minute: 'numeric'},
    monthYearLabel: {year: 'numeric', month: 'short'},
    dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
    monthYearA11yLabel: {year: 'numeric', month: 'long'},
};

// export const DATETIME_FORMATS = {
//     parseInput: 'LL LT',
//     fullPickerInput: 'YYYY-MM-DD HH:mm', /* <---- Here i've rewrited the format */
//     datePickerInput: 'LL',
//     timePickerInput: 'LT',
//     monthYearLabel: 'MMM YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'MM YYYY'
// };

